import React from "react";
import { Mail, MapPin } from "lucide-react";

const BOWER_LOGO = "https://customer-assets.emergentagent.com/job_9905ee30-c002-464f-b890-465ab6cc70dc/artifacts/9497g015_Bower%20School%20Logo-01.png";

// Shared brand footer used across BEAT, UG and (optionally) other program pages.
// Matches the visual language of the existing BEAT footer.
const SharedFooter = () => {
  return (
    <footer className="footer py-16 bg-[#0a0a0a] text-white" data-testid="shared-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <img
              src={BOWER_LOGO}
              alt="Bower School"
              className="h-12 object-contain brightness-0 invert mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-4">Building the next generation of industry disruptors.</p>
            <div className="flex flex-col gap-2 text-white/60 text-sm">
              <a href="mailto:ug@bowerschool.com" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-email-link">
                <Mail size={14} />
                ug@bowerschool.com
              </a>
              <span className="flex items-center gap-2">
                <MapPin size={14} />
                Hyderabad, India
              </span>
            </div>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Programs</h4>
            <nav className="flex flex-col gap-3">
              <a href="/beat" className="text-white/60 text-sm hover:text-white transition-colors">BEAT Test</a>
              <a href="/ug" className="text-white/60 text-sm hover:text-white transition-colors">UG BBA Programme</a>
              <a href="/gitam" className="text-white/60 text-sm hover:text-white transition-colors">GITAM x Bower BBA</a>
              <a href="/seed" className="text-white/60 text-sm hover:text-white transition-colors">SEED for Schools</a>
            </nav>
          </div>

          {/* Events */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Events</h4>
            <nav className="flex flex-col gap-3">
              <a href="/events" className="text-white/60 text-sm hover:text-white transition-colors">All Events</a>
              <a href="/admin/events" className="text-white/60 text-sm hover:text-white transition-colors">Manage Events</a>
            </nav>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Company</h4>
            <nav className="flex flex-col gap-3">
              <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer" className="text-white/60 text-sm hover:text-white transition-colors">Home</a>
              <a href="https://bowerschool.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-white/60 text-sm hover:text-white transition-colors">Terms of Service</a>
              <a href="https://bowerschool.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-white/60 text-sm hover:text-white transition-colors">Privacy Policy</a>
              <a href="https://bowerschool.com/refund-policy" target="_blank" rel="noopener noreferrer" className="text-white/60 text-sm hover:text-white transition-colors">Refund Policy</a>
            </nav>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 text-center text-white/40 text-sm">
          <p>&copy; {new Date().getFullYear()} Bower School of Entrepreneurship. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default SharedFooter;
